module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/12-3c802e6f075641b34ee28e52f56c755d.jpg";